$(document).on("autocomplete", ".company-selector .company-name", onCompanyAutocomplete);

document.addEventListener("DOMContentLoaded", function () {
  if ($(".company-selector").length > 0) {
    checkIfCompanySelected();
  }
});

function checkIfCompanySelected() {
  let company_id = getQueryParameter("company_id");
  let company_name = getQueryParameter("company_name");
  if (company_id != null && company_id != "") {
    $(".company-selector .company-id").val(company_id);
    $(".company-selector .company-name").val(company_name);
  }
}

function onCompanyAutocomplete({ detail: company }) {
  if (company) {
    $(".company-selector .company-id").val(company.id);
  } else {
    $(".company-selector .company-id").val("");
  }
}
